import request from "../requestConfig.js";
export default {
  getGoods(data) {
    return request({
      url: "/goods",
      method: "post",
      data
    });
  },
  getGoodsNum( data) {
    return request({
      url: "/goodsNum",
      method: "post",
      data
    });
  },
  addSingleGoods(customerCode, data) {
    return request({
      url: "/goods/single/" + customerCode,
      method: "post",
      data
    });
  },
  addMultiGoods(customerCode, data) {
    return request({
      url: "/goods/multi/" + customerCode,
      method: "post",
      data
    });
  },
  pushGoods(customerCode, data){
    return request({
      url: "/push/" + customerCode,
      method: "post",
      data
    });
  },
  getStores(customerCode) {
    return request({
      url: "/stores/" + customerCode,
      method: "get"
    });
  },

  getRecords(customerCode, data) {
    return request({
      url: "/records/" + customerCode,
      method: "post",
      data
    });
  },
  getRecordsNum(customerCode, data) {
    return request({
      url: "/recordsNum/" + customerCode,
      method: "post",
      data
    });
  },
  uploadFile(data) {
    return request({
      url: "/file/upload",
      method: "post",
      data
    });
  },
  login(data) {
    return request({
      url: "/login",
      method: "post",
      data
    });
  },
  deleteGoods(customerCode, sku){
    return request({
      url: "/goods/" + customerCode + "/" + sku,
      method: "delete",
    });
  },
  unbind(customerCode, data){
    return request({
      url: "/unbind/" + customerCode,
      method: "post",
      data
    });
  },
  existGoods(customerCode, sku){
    return request({
      url: "/goods/exist/" + customerCode + "/" + sku,
      method: "get"
    });
  },
};
